export type ViewTypesProps = {
  hasCity: boolean;
  hasGolfCourse: boolean;
  hasMountain: boolean;
  hasPark: boolean;
  hasTerritorial: boolean;
  hasWater: boolean;
  hasWooded: boolean;
};

const ViewTypes = ({
  hasCity = false,
  hasGolfCourse = false,
  hasMountain = false,
  hasPark = false,
  hasTerritorial = false,
  hasWater = false,
  hasWooded = false,
}: Partial<ViewTypesProps> = {}): ViewTypesProps => ({
  hasCity: Boolean(hasCity),
  hasGolfCourse: Boolean(hasGolfCourse),
  hasMountain: Boolean(hasMountain),
  hasPark: Boolean(hasPark),
  hasTerritorial: Boolean(hasTerritorial),
  hasWater: Boolean(hasWater),
  hasWooded: Boolean(hasWooded),
});

export default ViewTypes;
